export const PRIMARY_COLOR = "#c16d18";
export const PRIMARY_TEXT_COLOR = "#474d6a";
export const BANNER_BG  = "rgb(242 158 12 / 17%)";
// export const BANNER_BG  = "#f6ebdd";


// const GenerateInvoice = async () => {
  //   let Id;
  //   let totalamt;
  //   let userid;
  //   console.log("==== ==== =====")

  //   if (Array.isArray(selectedCandidate) && selectedCandidate.length > 0) {

      
  //     Id = selectedCandidate.map((ele) => ele.fld_id).join(",");
  //     console.log("==== One =====")

  //     totalamt = selectedCandidate.reduce(
  //       (acc, ele) =>
  //         acc +
  //         calculateValue({
  //           additionalamt: ele.fld_additionalamount,
  //           payableamt: ele.fld_payableamount * ele.fld_mandays,
  //         }),
  //       0
  //     );
  //     userid = selectedCandidate[0].fld_userid;
  //   } else if (selectedCandidate) {
  //     console.log("==== Two =====")
  //     Id = selectedCandidate.fld_id;
  //     totalamt = calculateValue({
  //       additionalamt: selectedCandidate.fld_additionalamount,
  //       payableamt: selectedCandidate.fld_payableamount * selectedCandidate.fld_mandays,
  //     });
  //     userid = selectedCandidate.fld_userid;
  //   }

  //   let payload = {
  //     userid: userid,
  //     auditid: Id,
  //     invoicetype: "work",
  //     totalamount: totalamt || 0,
  //   };

  //   console.log(payload, selectedCandidate, 'payload')
  //   return

  //   try {
  //     Notiflix.Loading.standard();

  //     const res = await PostApiCall.postRequest(payload, "JobGenerateInvoice");
  //     const json = await res.json();

  //     if (res.ok) {
  //       toast.success(json.data, {
  //         autoClose: delay,
  //       });

  //       setRefresh(true);
  //       setSelectedCandidate([]);
  //     } else {
  //       throw new Error(json.data);
  //     }
  //     Notiflix.Loading.remove();
  //   } catch (error) {
  //     Notiflix.Loading.remove();
  //     toast.error(error.message || SomethingWrong, {
  //       autoClose: delay,
  //       toastId: 1,
  //     });
  //   }

  //   setRecruiterRemarkModal(false);
  // };
